import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbDate} from '@ng-bootstrap/ng-bootstrap';
import {LanguageService, RoutingService, TranslationService} from '@spartacus/core';
import {Observable} from 'rxjs';
import {filter, map, tap} from 'rxjs/operators';
import {AimoRoutingService} from '../../cms-structure/routing/aimo-routing.service';
import {AimoCart} from '../../model/cart.model';
import {AimoOrderHistory, AimoOrderHistoryRequest} from '../../model/order.model';
import {AimoFacet, AimoFacetValue} from '../../model/product.model';
import {AimoGtmService} from '../../service/gtm/aimo-gtm.service';
import {AimoUserService} from '../../service/user/aimo-user.service';
import {AimoMessageService} from '../../service/util/aimo-message-service';
import {AimoNgbDateParserFormatter} from '../shared/datepicker/aimo-datepicker-parser-formatter';

const DEFAULT_PAGESIZE = 20;

@Component({
    selector: 'aimo-order-history',
    templateUrl: './aimo-order-history.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AimoOrderHistoryComponent implements OnInit {
    orders$: Observable<AimoOrderHistory>;

    facets: AimoFacet[] = [];
    searchForm: FormGroup;
    pageSizes = [10, DEFAULT_PAGESIZE, 50, 100, 500];
    resultSpan: string;
    // eslint-disable-next-line
    breadcrumbs$: Observable<any[]>;

    //  paging: (string | number)[];

    constructor(
        protected routing: RoutingService,
        protected router: Router,
        protected userService: AimoUserService,
        protected language: LanguageService,
        protected ngbDateParserFormatter: AimoNgbDateParserFormatter,
        protected activatedRoute: ActivatedRoute,
        protected messageService: AimoMessageService,
        protected routingService: RoutingService,
        protected cdr: ChangeDetectorRef,
        protected aimoRoutingService: AimoRoutingService,
        protected gtmService: AimoGtmService,
        private lTranslation: TranslationService,
    ) {
    }

    ngOnInit(): void {
        this.initSearch();
        // eslint-disable-next-line
        this.breadcrumbs$ = this.lTranslation.translate('aimo.orderhistory.title').pipe(
            filter(Boolean),
            map((translation) => [{label: translation, link: '/my-account/orders'}]),
        );
    }

    initSearch(): void {
        const searchTerm = this.activatedRoute.snapshot.queryParams?.searchTerm;
        this.searchForm = new FormGroup({
            search: new FormControl(searchTerm),
            from: new FormControl(this.convertDate(this.activatedRoute.snapshot.queryParams?.from)),
            to: new FormControl(this.convertDate(this.activatedRoute.snapshot.queryParams?.to)),
            pageSize: new FormControl(this.activatedRoute.snapshot.queryParams?.pageSize || DEFAULT_PAGESIZE),
            page: new FormControl(this.activatedRoute.snapshot.queryParams?.page || null),
        });
        this.fetchOrders();
    }

    doUrlSearch(resetPage: boolean): void {
        if (resetPage) {
            this.searchForm.controls.page.setValue(null);
        }
        this.router.navigate([],
            {
                relativeTo: this.activatedRoute,
                queryParams: {
                    searchTerm: this.searchForm.controls.search.value || null,
                    from: this.convertUrlDate(this.searchForm.controls.from.value),
                    to: this.convertUrlDate(this.searchForm.controls.to.value),
                    pageSize: this.searchForm.controls.pageSize.value || null,
                    page: this.searchForm.controls.page.value
                }
            }
        );
        this.fetchOrders();
    }

    private fetchOrders(): void {
        this.orders$ = this.userService.getOrderHistory({
            from: this.searchForm.controls.page.value || 0,
            size: this.searchForm.controls.pageSize.value || DEFAULT_PAGESIZE,
            sorts: [],
            facets: this.facets,
            deliveryDate: {
                from: this.searchForm.controls.from.value
                    ? this.ngbDateParserFormatter.toDate(this.searchForm.controls.from.value)
                    : null,
                to: this.searchForm.controls.to.value
                    ? this.ngbDateParserFormatter.toDate(this.searchForm.controls.to.value)
                    : null,
            },
            searchTerm: this.searchForm.controls['search'].value,
        } as AimoOrderHistoryRequest)
            .pipe(
                tap(orderHistory => this.setPaging(orderHistory))
            );
    }

    private setPaging(orderHistory): void {
        // this.paging = [];
        const first = 1 + orderHistory.pagination.currentPage * orderHistory.pagination.pageSize;
        const second = (orderHistory.pagination.currentPage + 1) * orderHistory.pagination.pageSize;
        this.resultSpan = first + ' - ' + (second > orderHistory.pagination.totalResults ? orderHistory.pagination.totalResults : second);

        /*   if (orderHistory.pagination.totalPages == 1) {
               return;
           }
           const visiblePages = MAX_PAGE_SELECTORS > orderHistory.pagination.totalPages ? orderHistory.pagination.totalPages : MAX_PAGE_SELECTORS;
           const center = visiblePages / 2;
           const start = orderHistory.pagination.currentPage - center > 1 ? orderHistory.pagination.currentPage - center : 1;
           this.paging.push(0);
           if (start > 1) {
               this.paging.push('...');
           }
           for (let i = 0; i < visiblePages; ++i) {
               const page = start + i;
               if (page < orderHistory.pagination.totalPages - 1 && page > 0) {
                   this.paging.push(page);
               }
           }
           if (orderHistory.pagination.currentPage + visiblePages < orderHistory.pagination.totalPages) {
               this.paging.push('...');
           }
           this.paging.push(orderHistory.pagination.totalPages - 1);*/
    }

    convertDate(d: string): NgbDate {
        return d ? this.ngbDateParserFormatter.parse(new Date(d)) : null;
    }

    convertUrlDate(d: NgbDate): string {
        return d ? this.ngbDateParserFormatter.toString(d) : null;
    }

    toggleFacet(facet: AimoFacet, facetValue: AimoFacetValue): void {
        //multiselect disabled
        /*     const existingFacet = facet && this.facets.find((f) => f.code === facet.code);
        if (existingFacet) {
            const existingValue = existingFacet.values.find(
                (val) => val.code === facetValue.code && facetValue.selected,
            );
            if (existingValue) {
                existingFacet.values = existingFacet.values.filter((val) => val.code !== facetValue.code);
            } else {
                existingFacet.values.push(facetValue);
            }
        } else*/
        if (facetValue) {
            this.facets = [{...facet, values: [facetValue]}];
        } else {
            this.facets = [];
        }
        this.fetchOrders();
    }

    getTotalOrders(facets: AimoFacet[]): number {
        return facets.flatMap((f) => f.values).reduce((sum, facetValue) => sum + facetValue.count, 0);
    }

    hideMessage(id: string, code: string): void {
        this.messageService.hideMessage(id + code);
        this.cdr.detectChanges();
    }

    isMessageHidden(id: string, code: string): boolean {
        return this.messageService.isMessageHidden(id + code);
    }

    unpaidOrders: AimoCart[];

    getUnPaidOrders(orderHistory: AimoOrderHistory): AimoCart[] {
        if (!this.unpaidOrders) {
            this.unpaidOrders = orderHistory.dayGroupedOrders
                .flatMap((o) => o.orders)
                .filter((o) => o.statusDisplay === 'PAYMENT_OPEN');
        }
        return this.unpaidOrders;
    }

    payNow(code: string): void {
        if (code) {
            this.routingService.go('/cart', {queryParams: {payNow: code}});
        }
    }

    isPikatukku(): boolean {
        return this.aimoRoutingService.isPikatukku();
    }

    pushGtmEvent(event: string): void {
        this.gtmService.pushEvent(event);
    }

    switchPage(page): void {
        this.searchForm.controls.page.setValue(page);
        this.doUrlSearch(false);
    }

    protected readonly isNaN = isNaN;

}
